export var BlockReasons;
(function(BlockReasons) {
    BlockReasons[/** deviation is marked as mature and the user has the mature filter enabled */ "MatureFilter"] = 'mature_filter';
    BlockReasons[/** deviation is marked as mature and the user is underage */ "MatureAge"] = 'mature_age';
    BlockReasons[/** deviation is marked as strict mature and the user is underage */ "StrictMatureAge"] = 'strict_mature_age';
    BlockReasons[/** deviation is marked as mature and the user is logged out */ "MatureLoggedOut"] = 'mature_loggedout';
    BlockReasons[/** current user has blocked this deviation */ "DeviationBlocked"] = 'deviation_blocked';
    BlockReasons[/** current user has the artist of this deviation blocked */ "ArtistBlocked"] = 'artist_blocked';
    BlockReasons[/** the author of this deviation has blocked the current user */ "BlockedByArtist"] = 'blocked_by_artist';
    BlockReasons[/** the deviation is marked as antisocial and the user is logged out */ "Antisocial"] = 'antisocial';
    BlockReasons[/** deviation is marked as nsfg */ "Nsfg"] = 'nsfg';
})(BlockReasons || (BlockReasons = {}));
